import styled from "styled-components";
import Colors from "modules/Colors";
import { makeStyles, Theme } from "@material-ui/core";

export const IconStyled = styled.img``;

export const useStyles = makeStyles((_theme: Theme) => ({
  inputBorder: {
    borderRadius: 6,
    width: "100%",
    height: "100%",
  },
  formHelperText: {
    "&.MuiFormHelperText-root": {
      fontSize: 16,
    },
  },
  textField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: Colors.purple,
      },
      "&:hover fieldset": {
        borderColor: Colors.purple,
      },
      "&.Mui-focused fieldset": {
        borderColor: Colors.purple,
      },
    },
    "& input": {
      fontFamily: "DIN",
      padding: "16px",
    },
    "& input::placeholder": {
      fontFamily: "DIN",
    },
  },

  // profile image
  imgStylesUserCircle: {
    width: "50px",
    height: "50px",
    objectFit: "cover",
    borderRadius: "50%",
  },
  imgStylesUserSquare: {
    width: "70px",
    height: "70px",
    objectFit: "cover",
    borderRadius: "20%",
  },
  liProfileArtist: {
    borderBottom: `1px solid ${Colors.textColorWhite}`,
    paddingBottom: "10px",
  },
}));